//
//
//
//
import effectScatter from '@/components/bigDataChart/effectScatter';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title'; // import { querySewageQuota } from '@/api/api'
// import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'servicePopulation',
  //   mixins: [listenMapChange],
  created: function created() {
    this.queryWaterType();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    dataMap: {
      type: Object,
      default: {}
    }
  },
  components: {
    effectScatter: effectScatter
  },
  methods: {
    queryWaterType: function queryWaterType(areaId, projectId) {
      var _this = this;

      setTimeout(function () {
        var datalist = [{
          offset: [85, 85],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#29c0fb'
          }, {
            offset: 1,
            color: '#2dc5b9'
          }])
        }, {
          offset: [40, 80],
          symbolSize: 50,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#35d17e'
          }, {
            offset: 1,
            color: '#49ddb2'
          }])
        }, {
          offset: [10, 43],
          symbolSize: 80,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#e5d273'
          }, {
            offset: 1,
            color: '#e4a37f'
          }])
        }, {
          offset: [44, 33],
          symbolSize: 80,
          opacity: 0.95,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#277aec'
          }, {
            offset: 1,
            color: '#57c5ec'
          }])
        }, {
          offset: [85, 30],
          symbolSize: 75,
          opacity: 0.7,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: '#11c46e'
          }, {
            offset: 1,
            color: '#f08456'
          }])
        }];
        var data = [{
          name: '水位',
          value: _this.dataMap['u20101'].value + "M"
        }, {
          name: '流量',
          value: _this.dataMap['u20201'].value + " ㎡/s"
        }, {
          name: '面积',
          value: _this.dataMap['u20401'].value + " ㎡"
        }, {
          name: '河埠头浊度',
          value: _this.dataMap['u11001'].value + " NTU"
        }, {
          name: '流速',
          value: _this.dataMap['u20301'].value + " cm/s"
        }];

        _this.$refs.chart1.initEffectScatterChart(data, datalist);
      }, 1000);
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWaterType(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWaterType(value, this.currentProjectId)
  //     },
  //   },

};